<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			v-if="skillDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleSkills from "@/store/skills/moduleSkills.js";

export default {
	name: "CellRendererActions",
	data() {
		return {
			skillListCopy: [],
			isRemove: true,
			timeoutCount: null,
			loading: true,
			percent: 0,
		};
	},
	computed: {
		skillDeletePermission() {
			return this.$store.getters.checkPermission("SKILLS_D");
		},
		dataSkill() {
			return this.$store.state.moduleSkills.skills;
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/dashboard/update-skill/" + this.params.data.id).catch(() => {});
		},
		confirmUndo() {
			this.skillListCopy = [...this.dataSkill];
			this.$store.commit("moduleSkills/ADD_ID_SKILL", this.params.data.id);
			this.$store.commit("moduleSkills/REMOVE_SKILL", this.params.data.id);
			this.$vs.notify({
				title: `${this.$t(
					"Skills.Messages.TitleConfirmDelete"
				)} <a id="undoOperation" class="button-undo">${this.$t("Undo")}</a>`,
				text: `"${this.params.data.name}"`,
				color: "success",
				time: 10000,
			});
			let notifyActive = document.querySelector(".vs-notifications .content-noti .con-text-noti");
			notifyActive.insertAdjacentHTML(
				"beforeend",
				`
				<div
					class="vs-progress--background vs-progress-primary indeterminate" style="background: white; height: 6px;"
				>
					<div class="vs-progress--foreground" style="width: 0%;"></div>
					<div class="vs-progress--indeterminate" style="width: 0%;"></div>
				</div>`
			);
			document.getElementById("undoOperation").addEventListener("click", () => {
				this.isRemove = false;
				this.$store.commit("moduleSkills/REMOVE_ID_SKILL", this.params.data.id);
				this.$store.commit("moduleSkills/SET_SKILLS", []);
				this.$store.commit("moduleSkills/SET_SKILLS", this.skillListCopy);
			});
			this.timeoutCount = setTimeout(() => {
				if (this.isRemove) {
					this.deleteRecord();
				}
			}, 10000);
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Skills.DeleteSkill.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("Skills.DeleteSkill.Text2"),
				accept: this.confirmUndo,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleSkills/removeItem", this.params.data.id)
				.then((res) => {
					clearTimeout(this.timeoutCount);
					this.$store.commit("moduleSkills/REMOVE_ID_SKILL", this.params.data.id);
					return res;
				})
				.catch((err) => {
					console.error(err);
					clearTimeout(this.timeoutCount);
				});
		},
	},
	created() {
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
	},
};
</script>
<style lang="scss">
.button-undo {
	border-bottom: 2px solid;
	color: rgb(92, 91, 91);
	margin-left: 5px;
	font-weight: bold;
	cursor: pointer;
	font-size: 14px;
}
</style>
